
import "@sparta.sales.modules/ml-lms-module/dist/styles.css"


import spartaBootstrapUtility from "@sparta.global.utilities/sparta-bootstrap-utility/dist/es6.js"

import "@sparta.sales.modules/ml-lms-module/dist/es6.js"
import "@sparta.ml-outage.modules/ml-dynamic-footer-module/dist/es6.js"


window.spaParams = window.spaParams || {};
window.spaParams.dynamicImportMap = {
  modules: [
    {
      name: "@sparta.ml-shared.modules/ml-power-footer-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/ml-shared-ml-power-footer-module-es6" */ "@sparta.ml-shared.modules/ml-power-footer-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/ml-shared-ml-power-footer-module-styles" */ "@sparta.ml-shared.modules/ml-power-footer-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.global.vendors/vue",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vue" */ "@sparta.global.vendors/vue" )}
    },
    {
      name: "@sparta.global.vendors/vuex",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vuex" */ "@sparta.global.vendors/vuex" )}
    },
    {
      name: "@sparta.global.vendors/vue-router",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vue-router" */ "@sparta.global.vendors/vue-router" )}
    }
  ],
  stores: [
    {
      namespace: "@sparta.global-tenants.stores/gt-unauth-bootstrap-store",
                   loader: function() { return import( /* webpackChunkName: "spa-assets/js/stores/@sparta.global-tenants.stores/gt-unauth-bootstrap-store-es6" */ "@sparta.global-tenants.stores/gt-unauth-bootstrap-store/dist/es6.js" )}
    }
  ],
  jcrs: [
    {
      name: "site/ml-outage/module-specific/power-footer-section/en/power-footer-section.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-ml-outage-module-specific-power-footer-section-en-power-footer-section.json" */ "file:///apps/wt/deploy/tmp/3E6FC2D6/build/sit1/site/ml/spa-assets/data/site-ml-outage-module-specific-power-footer-section-en-power-footer-section-en-T1785503783132.json" )}
    }
  ]
}




// Add fingerprint spa-map.json into spaParams

// Initialize page
;(async function() {
  console.log('INIT PAGE')
  console.log('before - execute boot functions')
  await spartaBootstrapUtility.init(arguments);
  console.log('after - execute boot functions')
})();
